import { useScrollReveal } from '@/hooks/useScrollReveal';

const institutions = [
  {
    name: 'Sharanya Narayani International School',
    distance: 'Opposite to Confident Auriga',
    description: 'Prestigious educational institution with excellent connectivity from the project location.',
    icon: 'ri-graduation-cap-line',
  },
  {
    name: 'Garden City University',
    distance: '2 Minutes Away',
    description: 'Renowned university campus offering diverse academic programs and modern research facilities.',
    icon: 'ri-building-2-line',
  },
  {
    name: 'VIT University',
    distance: 'Approx. 10 Minutes Away',
    description: 'Leading technology and research university with strong industry and placement connections.',
    icon: 'ri-book-open-line',
  },
];

export default function NearbyInstitutions() {
  useScrollReveal('.institution-reveal', 0.1);

  return (
    <section className="py-10 md:py-16 bg-cream border-t border-cream-dark/30">
      <div className="section-padding">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-12">
          <div className="institution-reveal scroll-reveal">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary/5 border border-primary/10 rounded-full font-body text-[10px] md:text-xs tracking-[0.2em] uppercase text-primary">
              <span className="w-1.5 h-1.5 bg-gold rounded-full" />
              Connectivity
            </span>
          </div>
          <h2 className="institution-reveal scroll-reveal font-display text-2xl md:text-4xl lg:text-5xl text-charcoal font-bold mt-4 md:mt-5 leading-tight">
            Nearby Institutions & <span className="text-gradient-gold">Connectivity</span>
          </h2>
          <p className="institution-reveal scroll-reveal font-body text-sm md:text-base text-charcoal/60 mt-3 md:mt-4 max-w-2xl mx-auto leading-relaxed">
            Premier educational destinations within easy reach of Confident Auriga Malur, enhancing long-term lifestyle and investment value for families seeking premium plots near Bangalore. Access to reputed institutions like VIT University, Garden City University, and Sharanya Narayani International School makes this an ideal choice for families prioritizing quality education for their children. Proximity to these campuses also drives rental demand and property appreciation, strengthening the investment case for villa plots in Malur. When you choose gated community plots in Malur with educational infrastructure nearby, you invest not just in land, but in your family's future and the sustained value of your land investment near Bangalore.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {institutions.map((item, index) => (
            <div
              key={item.name}
              className="institution-reveal scroll-reveal bg-white rounded-2xl p-6 md:p-7 border border-cream-dark/50 hover:border-gold/30 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-gold/5 group"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary/5 flex items-center justify-center mb-4 group-hover:bg-gold/10 transition-colors duration-500">
                <i className={`${item.icon} text-primary text-xl md:text-2xl group-hover:text-gold transition-colors duration-500`}></i>
              </div>
              <h3 className="font-display text-base md:text-lg text-charcoal font-semibold mb-2 leading-snug">
                {item.name}
              </h3>
              <p className="font-body text-xs md:text-sm text-gold font-medium tracking-wide mb-3">
                {item.distance}
              </p>
              <p className="font-body text-xs md:text-sm text-charcoal/60 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}